import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-course-comparison-home',
  templateUrl: './course-comparison-home.component.html',
  styleUrls: ['./course-comparison-home.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class CourseComparisonHomeComponent implements OnInit{

  @Input('pageType') pageType:any;

  tableData:any[]= [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Assignments', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Non-Engineer's Quants Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Engineer's VARC Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'CAT LRDI Inception', colorText: " ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'AI Mock Analysis', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Special initiatives (QA250,LRDI70)', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Peer to Peer Learing', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Free 2 Month Crash Course', colorText: ' ', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '7500 CAT Qs IIM ABC Course', colorText: '', subText: '', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'IIM ABC Practice Sessions', colorText: '', subText: '(Daily 12 QA, 3 RCs & 3 LRDI Sets)', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "12 Sets: CAT'24 level Books", colorText: '', subText: '', img1: '',
      img2: '', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
  ]

  showContent:boolean = false;

  constructor(){}

  ngOnInit(): void {
  }


}
